import { Component, Input, OnInit, DOCUMENT, inject } from '@angular/core';

@Component({
  selector: 'bepatient-onboarding-navigation-button',
  templateUrl: './onboarding-navigation-button.component.html',
  styleUrls: ['./onboarding-navigation-button.component.scss'],
  standalone: false
})
export class OnboardingNavigationButtonComponent {
  document = inject(DOCUMENT);

  fill = '#6B3CD9';
  iconFill =
    'var(--ion-color-accent-accessible-button-text, var(--ion-background-color))';
  transform = 'scale(1, 1) translate(0, 0)';

  @Input() set color(v) {
    this.fill = v || '#6B3CD9';
  }

  @Input() set iconColor(v: string | null | undefined) {
    this.iconFill =
      v ||
      'var(--ion-color-accent-accessible-button-text, var(--ion-background-color))';
  }

  @Input() set reversed(v) {
    this.transform = v
      ? 'scale(1, 1) translate(0, 0)'
      : 'scale(-1, 1) translate(-45, 0)';
  }
}
